/**
 * useCamera — camera guide frame utilities
 */

import type { CSSProperties } from 'react';
import type { CameraModalProps } from './types';

export function getCameraGuideFrameStyle(
  mode: NonNullable<CameraModalProps['guide']>['mode'],
  isLandscape: boolean,
): CSSProperties {
  switch (mode) {
    case 'receipt':
      return isLandscape
        ? { width: '30%', height: '82%' }
        : { width: '46%', height: '82%' };
    case 'invoice':
      return isLandscape
        ? { width: '64%', height: '84%' }
        : { width: '84%', height: '72%' };
    case 'continuous':
      return isLandscape
        ? { width: '34%', height: '88%' }
        : { width: '52%', height: '88%' };
    case 'vehicle':
      // Vehicle photos are wide — landscape is the natural orientation.
      // The frame is larger than document frames because the vehicle body
      // should fill most of the photo for AI analysis.
      return isLandscape
        ? { width: '88%', height: '72%' }
        : { width: '82%', height: '62%' };
    case 'auto':
    default:
      return isLandscape
        ? { width: '54%', height: '82%' }
        : { width: '72%', height: '78%' };
  }
}
